import { render, staticRenderFns } from "./QuoteCommunications.vue?vue&type=template&id=42c84604&scoped=true"
import script from "./QuoteCommunications.vue?vue&type=script&lang=js"
export * from "./QuoteCommunications.vue?vue&type=script&lang=js"
import style0 from "./QuoteCommunications.vue?vue&type=style&index=0&id=42c84604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c84604",
  null
  
)

export default component.exports